<template>
  <div :class="$style.container">
    <div :class="$style.label">Статус:</div>
    <div
      v-for="(item,i) in chain"
      :class="[$style.item, item.active && $style.itemActive]"
      :style="{color: item.color}"
    >
      {{ item.title }}
      <app-icon v-if="i !== chain.length - 1" :class="$style.icon" name="ChevronDown" size="12px" />
    </div>
  </div>
</template>

<script>
import arrayToIdIndex from "@/client/helpers/arrayToIdIndex";

const chain = [
  { status: 6, isActive: ( statusId ) => statusId === 6 },
  { status: 4, isActive: ( statusId ) => statusId === 4 },
  { status: 3, isActive: ( statusId ) => statusId === 3 },
  { status: 1, isActive: ( statusId ) => statusId === 1 || statusId === 2 },
];

export default {
  name:     "IssueStatus",
  props:    ['history', 'statusId'],
  computed: {
    chain() {
      const statuses = arrayToIdIndex(Object.values(this.$store.getters['common/tasks/statuses']));
      const { statusId, history } = this;

      if (statusId === 5) {
        const status = statuses[5];

        const items = [];
        for (let i = 0; i < chain.length; i++) {
          const item = chain[i];
          const prevItem = items[0];
          const active = history.some(h => item.isActive(h.status_id));
          const itemStatus = statuses[item.status];
          if (active || prevItem) items.unshift({
            title:  itemStatus.name,
            color:  null,
            active: true,
          });
        }
        items.push({ title: status.name, color: status.color, active: true });
        return items;
      }

      const items = [];
      for (let i = 0; i < chain.length; i++) {
        const item = chain[i];
        const prevItem = items[0];
        const active = item.isActive(statusId);
        const itemStatus = statuses[item.status];
        items.unshift({
          title:  itemStatus.name,
          color:  active ? itemStatus.color : null,
          active: active || (prevItem && prevItem.active),
        });
      }
      return items;

    },
    status() {
      return this.$store.getters['common/tasks/statusById'](this.statusId);
    },
  },
};
</script>

<style lang="scss" module>
.container {
  display: flex;
  height: 100%;
  align-items: center;
  font-size: 1.25rem;
}

.label {
  font-weight: 600;
  margin-right: 1em;
}

.item {
  opacity: .3;
  font-weight: 500;
  @include anim();
}

.itemActive {
  opacity: 1;
  font-weight: 600;
}

.icon {
  transform: rotate(-90deg);
  margin: 0 1em;
}
</style>
